import React, { useState } from 'react';
import { Button } from '../button/button';
import { __ } from '../../../utils/translation-service';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import { ImageListItemBar } from '@mui/material';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import Fullscreen from 'yet-another-react-lightbox/plugins/fullscreen';
import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails';
import 'yet-another-react-lightbox/plugins/thumbnails.css';
import { StyledButtonWrapper, StyledLightboxGalleryIcon } from './lightbox-gallery.style';

export interface IImage {
    src: string;
    alt: string;
    placeholder: string;
}

interface IProps {
    images: IImage[];
}

export const LightboxGallery = ({ images }: IProps) => {
    const [index, setIndex] = useState(-1);

    // to modify the size and the view of the images
    const srcset = (image: string, _size: number, _rows = 1, _cols = 1) => {
        return {
            src: `${image}`,
            srcSet: `${image} 2x`,
        };
    };

    const galleryThumbnails = [
        {
            img: images[0]?.src,
            title: images[0]?.alt,
            rows: 2,
            cols: 2,
            index: 0,
        },
        {
            img: images[1]?.src,
            title: images[1]?.alt,
            index: 1,
        },
        {
            img: images[2]?.src,
            title: images[2]?.alt,
            index: 2,
        },
    ];

    const showGalleryThumbnails = images.length >= 3;

    const slides = images.map((image) => {
        return {
            src: image.src,
            alt: image.alt,
            placeholder: image.placeholder,
        };
    });
    if (images?.length === 0) return null;
    return (
        <ImageList variant="quilted" cols={showGalleryThumbnails ? 3 : 1} gap={9} rowHeight={200}>
            {(showGalleryThumbnails ? galleryThumbnails : [galleryThumbnails[0]]).map((item) => {
                if (!item.img) {
                    return null;
                }
                return (
                    <ImageListItem
                        key={item.img}
                        cols={item.cols || 1}
                        rows={item.rows || 1}
                        style={{ cursor: 'pointer' }}
                        onClick={() => setIndex(item.index)}
                    >
                        <img
                            {...srcset(item.img, 200, item.rows, item.cols)}
                            alt={item.title}
                            loading="lazy"
                        />
                        {/* Displays the bar only on the third image  */}
                        {item.index === 2 && (
                            <ImageListItemBar
                                sx={{
                                    position: 'absolute',
                                    top: '50%',
                                    marginTop: '-22px',
                                    height: '44px',
                                    textAlign: 'center',
                                    background: 'transparent',
                                }}
                                actionIcon={
                                    <StyledButtonWrapper>
                                        <Button
                                            variant="outlined"
                                            onClick={() => setIndex(item.index)}
                                        >
                                            <StyledLightboxGalleryIcon />
                                            {__('viewAllPhotos')}
                                        </Button>
                                    </StyledButtonWrapper>
                                }
                            />
                        )}
                    </ImageListItem>
                );
            })}

            <Lightbox
                open={index >= 0}
                index={index}
                close={() => setIndex(-1)}
                slides={slides}
                carousel={{
                    finite: !showGalleryThumbnails,
                }}
                plugins={[Fullscreen, Thumbnails]}
            />
        </ImageList>
    );
};
